<template>
	<div id="sidebar">
		<router-link class="logo" to="/">
			<img src="@/assets/img/logo.png" />
		</router-link>
		<div class="quick-menu">
			<h5 class="menu-title" style="margin-bottom: 10px">빠른 메뉴</h5>
			<e-btn
				:icon="require('@/assets/img/button-doc.png')"
				text="시험의뢰"
				@click="$router.push('/project/form/add')"
			/>
			<e-btn
				:icon="require('@/assets/img/button-add-person.png')"
				text="고객추가"
				@click="$router.push('/client/form/add')"
			/>
		</div>
		<nav class="menu">
			<h5 class="menu-title">작업</h5>
			<router-link
				v-for="(item, index) in menu"
				:key="`menu-${index}`"
				:to="item.path"
				v-show="canShowMenu(item)"
			>
				<e-btn
					:icon="require(`@/assets/img/${item.img}`)"
					:text="item.name"
					:styleType="isMenuActive(item) ? '' : 'text'"
				/>
			</router-link>
		</nav>
		<div class="profiles" v-if="profile.name">
			<div class="box">
				<v-avatar>
					<span class="white--text text-h5">{{
						profile.name.slice(0, 1)
					}}</span>
				</v-avatar>
				<div class="txtbox">
					<b>{{ profile.name }}</b>
					<p>{{ profile.email }}</p>
				</div>
				<b-dropdown class="profile-dropdown">
					<template #button-content>
						<img src="@/assets/img/sidebar-menu5.png" />
					</template>
					<b-dropdown-item-button @click="showModal"
						>프로필 수정</b-dropdown-item-button
					>
					<b-dropdown-item-button @click="goUpdateEdit"
						>기능 수정 요청</b-dropdown-item-button
					>
					<b-dropdown-item-button @click="goUpdate"
						>업데이트 기록 바로가기</b-dropdown-item-button
					>
					<b-dropdown-item-button @click="logout"
						>로그아웃</b-dropdown-item-button
					>
				</b-dropdown>
			</div>
			<modal-profile
				ref="modal-profile"
				:info="profile"
				@submit="onSubmit"
			/>
			<!--<b-button size="sm" @click="logout">로그아웃</b-button>-->
		</div>
	</div>
</template>

<script>
import { menu } from '@/utils/menu'
import ModalProfile from '../modal/ModalProfile.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters('user', ['profile', 'canAccessPage'])
	},
	components: {
		ModalProfile
	},
	data() {
		return {
			menu: menu
		}
	},
	methods: {
		/**
		 * 메뉴 노출 판정 — 권한 매트릭스(세부 권한 설정)를 정본으로 본다.
		 *
		 * 종전에는 menu.js 에 하드코딩된 permission 배열만 봤다.
		 * 그래서 관리자 대시보드에서 역할×기능을 바꿔도 메뉴에는 반영되지 않았고,
		 * 라우터 가드(canAccessPage 사용)와 판정이 서로 달랐다 —
		 * 접근은 되는데 메뉴만 안 보이는 상태가 됐다(2026-08-17 신고: TECH_ADMIN).
		 *
		 * pageKey 가 있으면 매트릭스로 판정하고, 없을 때만 종전 배열을 쓴다.
		 * canAccessPage 는 권한 적재 실패 시 역할 기반 판정으로 자동 폴백한다.
		 */
		canShowMenu(item) {
			if (item?.pageKey) return this.canAccessPage(item.pageKey);
			if (item?.permission) return item.permission.includes(this.profile.permission);
			return true;
		},
		isMenuActive(item) {
			// 라우트 meta.pageKey 우선 매칭 ('project.excelUpload' 같은 하위 키도 상위 메뉴로 매칭)
			const routePageKey = this.$route.meta?.pageKey
			if (routePageKey && item.pageKey) {
				return (
					routePageKey === item.pageKey ||
					routePageKey.split('.')[0] === item.pageKey
				)
			}
			// fallback: 쿼리스트링(clientId 등) 오탐 방지를 위해 path 기준으로 판정
			if (item.page) {
				return this.$route.path.includes(item.page)
			}
			return this.$route.path === item.path
		},
		...mapActions('user', ['updateProfile']),
		logout() {
			this.$router.push('/logout')
		},
		showModal() {
			this.$bvModal.show('modal-profile')
		},
		async onSubmit(form, complete) {
			try {
				await this.updateProfile(form)
				await this.$toast.success('프로필을 수정하였습니다.')
				await this.$refs['modal-profile'].onHide()
			} catch (e) {
				const msg = e?.response?.data?.msg || '프로필 수정에 실패했습니다.'
				this.$toast.error(msg)
			} finally {
				if (typeof complete === 'function') complete()
			}
		},
		goUpdate() {
			window.open(
				'https://docs.google.com/spreadsheets/d/1JZFcJRfOZk_wTTGnjW6WifxGklRoqjhZCb85iDuUi00/edit?gid=940962190#gid=940962190',
				'_blank'
			)
		},
		goUpdateEdit() {
			window.open(
				'https://docs.google.com/forms/d/e/1FAIpQLSdsRsVEAONydvDmwKR_kGKk1sDGD_aM03lGSCBs6pmsBiK20Q/viewform?usp=dialog',
				'_blank'
			)
		}
	}
}
</script>

<style lang="scss" scoped>
#sidebar {
	.profiles {
		display: block !important;
		min-height: 70px;
		padding: 10px;
		height: unset;
		.box {
			display: flex;
			align-items: center;
		}
		button {
			width: 100%;
			margin-top: 10px;
		}
	}
	:deep(.profile-dropdown) {
		.dropdown-toggle {
			background-color: transparent;
			border-color: transparent;
			&::after {
				display: none;
			}
		}
	}
}
</style>
